import { useState, useEffect } from "react";

const ErrorComponent = ({
  error = true,
  message = "Page Not Found",
  desc = "The page you're looking for doesn't exist or has been moved.",
  button = "Back to Home",
  href = "/",
}) => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  return (
    <>
      <div className="flex-grow flex flex-col items-center justify-center mt-[80px] px-4 py-40 relative">
        {error && (
          <div
            className={`transform transition-all duration-1000 ${
              isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
            }`}
          >
            <h1 className="text-8xl md:text-9xl font-bold text-transparent bg-clip-text bg-gradient-to-r from-amber-500 to-orange-600">
              404
            </h1>
          </div>
        )}

        {error && (
          <div
            className={`w-16 h-1 bg-gradient-to-r from-amber-400 to-orange-400 rounded my-6 transition-all duration-1000 ${
              isVisible ? "w-16 opacity-100" : "w-0 opacity-0"
            }`}
          ></div>
        )}

        <div
          className={`text-center transition-all duration-1000 delay-300 ${
            isVisible ? "translate-y-0 opacity-100" : "translate-y-10 opacity-0"
          }`}
        >
          <h2 className="text-2xl md:text-4xl font-light mb-2">{message}</h2>
          <p className="text-gray-600 text-base md:text-lg mb-8">{desc}</p>

          <a
            className="px-6 py-3 bg-gradient-to-r from-amber-500 to-orange-400 rounded-lg font-medium text-white hover:from-amber-600 hover:to-orange-500 transform transition-all duration-300 hover:scale-105 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-amber-400 z-10 cursor-pointer"
            href={href}
          >
            {button}
          </a>
        </div>

        {/* Decorative elements */}
        <div className="absolute top-1/3 left-1/4 w-64 h-64 bg-amber-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob pointer-events-none -z-10"></div>
        <div className="absolute top-1/3 right-1/4 w-64 h-64 bg-orange-200 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-2000 pointer-events-none -z-10"></div>
        <div className="absolute bottom-1/3 left-1/3 w-64 h-64 bg-amber-100 rounded-full mix-blend-multiply filter blur-3xl opacity-20 animate-blob animation-delay-4000 pointer-events-none -z-10"></div>

        <style jsx>{`
          @keyframes blob {
            0% {
              transform: scale(1);
            }
            33% {
              transform: scale(1.1) translate(10%, 10%);
            }
            66% {
              transform: scale(0.9) translate(-10%, -10%);
            }
            100% {
              transform: scale(1);
            }
          }
          .animate-blob {
            animation: blob 7s infinite;
          }
          .animation-delay-2000 {
            animation-delay: 2s;
          }
          .animation-delay-4000 {
            animation-delay: 4s;
          }
        `}</style>
      </div>
    </>
  );
};

export default ErrorComponent;